<template>
    <div class="upload-box">
        <div class="avatar-uploader" v-if="type == 1 && uploadUrl == 'image'" flex="main:center cross:center" :class="size">
            <div v-if="!image" flex="dir:top">
                <el-upload
                    :action="action"
                    style="display: inline-block"
                    :headers="headers"
                    :data="edata"
                    name="upload"
                    :show-file-list="false"
                    :on-success="fileSuccess"
                    :before-upload="beforeUpload">
                    <el-link>上传{{size != 'small' ? '图片' : ''}}</el-link>
                </el-upload>
                <!-- <el-link @click="fileDialog = true">{{size != 'small' ? '图库' : ''}}选择</el-link> -->
            </div>
            <div v-else>
                <el-image class="image" :src="$util.img(image)" :preview-src-list="[$util.img(image)]" fit="cover"></el-image>
                <div class="position-btns" flex="cross:center">
                    <el-upload
                    :action="action"
                    style="display: inline-block"
                    :headers="headers"
                    :data="edata"
                    name="upload"
                    class="flex-1"
                    :show-file-list="false"
                    :on-success="fileSuccess"
                    :before-upload="beforeUpload" flex="">
                        <a href="javascript:;" class="flex-1">上传</a>
                    </el-upload>
                    <!-- <span class="line"></span> -->
                    <!-- <a href="javascript:;" class="flex-1" @click="fileDialog = true">选择</a> -->
                </div>
            </div>
        </div>
        <div class="video-uploader" v-if="type == 1 && uploadUrl == 'video'">
            <div flex="cross:center">
                <el-upload
                    :action="action"
                    style="display: inline-block"
                    :headers="headers"
                    :data="edata"
                    name="upload"
                    :show-file-list="false"
                    :on-success="fileSuccess"
                    :before-upload="beforeUpload">
                <div>
                    <el-button type="success">上传视频</el-button>
                </div>
                </el-upload>
                <el-button type="primary" @click="fileDialog = true">图库选择视频</el-button>
                <el-button type="danger" style="margin-left:0" v-if="image" @click="deleteVideo">删除视频</el-button>
            </div>
            <div class="video" v-if="image">
                <video controls :src="$util.img(image)"></video>
            </div>

        </div>

        <div v-if="type == 2" flex="">
            <el-upload
                :action="action"
                style="display: inline-block"
                :headers="headers"
                multiple
                :data="edata"
                name="upload"
                v-if="type == 2"
                :show-file-list="false"
                :on-success="fileSuccess"
                :before-upload="beforeUpload">
                <el-button v-if="type == 2" :size="size" type="success">{{text?text:'点击上传'}}</el-button>
            </el-upload>
            <!-- <el-button type="primary" :size="size" @click.stop="toSelectFile">图库选择</el-button> -->
        </div>

        <el-upload
            :action="action"
            style="display: inline-block"
            :headers="headers"
            multiple
            :data="edata"
            name="upload"
            v-if="type == 3"
            :show-file-list="false"
            :on-success="fileSuccess"
            :before-upload="beforeUpload">
            <el-button v-if="type == 3">上传p12证书</el-button>
        </el-upload>

        <div class="avatar-uploader" v-if="type == 4" flex="main:center cross:center">
            <el-upload
                :action="action"
                style="display: inline-block"
                :headers="headers"
                :data="edata"
                name="upload"
                :show-file-list="false"
                :on-success="fileSuccess"
                :before-upload="beforeUpload">
                <div>
                    <video controls style="max-width: 120px;max-height: 120px;" v-if="image && (image.indexOf('.mp4') > 0 || image.indexOf('.avi') > 0)" :src="image" class="avatar" />
                    <img style="max-width: 120px;max-height: 120px;" v-else-if="image" :src="$util.img(image)" class="avatar" />
                    <i v-else style="font-size: 30px;" class="el-icon-plus avatar-uploader-icon"></i>
                </div>
            </el-upload>
            <div class="intro-text" v-if="type == 1 && image">点击更换</div>
        </div>

		<el-dialog title="从图库选择" :visible.sync="fileDialog" append-to-body>
            <FileList v-if="fileDialog" @success="fileSelectSuccess"></FileList>
		</el-dialog>
    </div>
</template>

<script>
import FileList from './FileList.vue'
export default {
    props: {
        type: {
            type: Number,
            default: 1,
        },
        url: {
            type: String,
            default: '',
        },
        size: {
            type: String,
            default: 'default'
        },
        edata: {
            type: Object,
            default: null,
        },
        uploadUrl: {
            type: String,
            default: 'image'
        },
        text: {
            type: String,
            default: ''
        }
    },
    data(){
        return {
            action: '',
            headers: {},
            image: '',

            fileDialog: false,

            selectDialog: false,
        }
    },
    components: {
        FileList,
    },
    mounted() {
        this.init()
    },
    watch: {
        url(info){
            this.image = info
        }
    },
    methods: {
        init(){
            this.action = this.$config.baseUrl + '/api/front/file/upload/' + this.uploadUrl;
            this.headers = {'Authorization': this.$util.cacheGet("authToken")};
            if(this.url){
                this.image = this.url;
            }
        },
        deleteVideo(){
            this.image = ''
            this.$emit('deleteVideo')
        },
        fileSuccess(res, file) {
            if(res.status == 1){
                this.image = res.data.url;
                this.selectDialog = false;
                this.$emit('success', res.data);
            }else{
                this.$message({
                    message: res.msg,
                    type: 'error'
                })
            }
        },
        fileSelectSuccess(row){
            this.image = row.url;
            this.fileDialog = false;
            this.selectDialog = false;
            this.$emit('success', {
                url: row.url
            })
        },
        beforeUpload(file){
        },
        toSelectFile(){
            this.fileDialog = true;
        }
    }
}
</script>

<style lang="scss" scoped>
    .upload-box{
        display: inline-block;
    }
    .avatar-uploader{
        width: 120px;
        height: 120px;
        border: 1px dashed #ccc;
        overflow: hidden;
        font-size: 0;
        cursor: pointer;
        position: relative;
        .position-btns{
            position: absolute;
            left: 0;
            bottom: 0;
            z-index: 10;
            width: 100%;
            background: rgba(0,0,0,0.7);
            height: 20px;
            a{
                color: #fff;
                text-decoration: none;
                text-align: center;
                font-size: 12px;
            }
            .line{
                width: 1px;
                background: rgba(255,255,255,0.4);
                height: 20px;
            }
        }
        .image{
            width: 120px;
            height: 120px;
        }
        .select-btns{
            position: absolute;
            left: 0;
            top: 0;
            width: 120px;
            height: 120px;
            background: rgba(0,0,0,0.4);
        }
        .intro-text{
            position: absolute;
            bottom: 0;
            left: 0;
            background: rgba(0,0,0,0.7);
            color: #fff;
            width: 100%;
            height: 20px;
            line-height: 20px;
            text-align: center;
            overflow: hidden;
            font-size: 12px;
        }
        &.small{
            width: 60px;
            height: 60px;
            .image{
                width: 60px;
                height: 60px;
            }
        }
    }
    
    .video-uploader{
        .video{
            padding-top: 20px;
            video{
                width: 300px;
                background: #000;
            }
        }
    }
</style>


// WEBPACK FOOTER //
// src/components/Upload.vue